import { render, staticRenderFns } from "./TaishokutodokeCompanyCard.vue?vue&type=template&id=393e7d77"
import script from "./TaishokutodokeCompanyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaishokutodokeCompanyCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports